import narrative from './narrative';
import share from './share';

window.onload = () => {

	if ($('.js-narrative__page').length > 0) {
    narrative();
  }

  if ($('.js-share').length > 0) {
    share();
  }

};
